module.exports = __webpack_public_path__ + "img/SKMJ_line1.4d1a35b3.jpg";